import {Box, Item} from "devextreme-react/box";
import {SelectBox} from "devextreme-react/select-box";
import {RequiredRule, Validator} from "devextreme-react/validator";
import DateBox, {IDateBoxOptions} from "devextreme-react/date-box";
import {NativeEventInfo} from "devextreme/events";
import dxDateBox from "devextreme/ui/date_box";
import {useState} from "react";
import {formatShortTime, setTimeForDate} from "../../utils/date-utils";
import './DateWithTimeBox.scss'

interface DateWithTimeBoxProps extends React.PropsWithChildren<IDateBoxOptions> {
	startHour: number,
	endHour: number,
	stepInMinutes: number,
	timeRequired?: boolean
}

export default function DateWithTimeBox(props: DateWithTimeBoxProps) {

	let [date, setDate] = useState(props.value as Date);
	let [time, setTime] = useState(formatShortTime(props.value as Date));

	let timeList = [];
	const minutes = ["00", "30"];

	for (let hour = props.startHour; hour <= props.endHour; hour++) {
		var hour12 = hour > 12 ? hour - 12 : hour;
		for (let m = 0; m < 2; m++) {
			let t = hour12 + ":" + minutes[m] + " " + (hour > 11 ? "PM" : "AM");
			timeList.push(t);
			if (hour === props.endHour) // do not need :30 for the last hour
				break;
		}
	}

	return (
		<Box className="date-with-timeframe">
			<Item ratio={1}>
				<DateBox {...props}
					value={props.value}
					onValueChanged={(e) => {
						var previousValue = date;
						var newValue = e.value;
						setDate(newValue);
						if (!newValue)
							setTime(undefined);

						props.onValueChanged && props.onValueChanged({ ...e, previousValue: previousValue, value: newValue });
					}}>
					{props.children}
				</DateBox>
			</Item>
			<Item ratio={1}>
				<SelectBox
					className={props.timeRequired && !!date ? "required" : ""}
					readOnly={!date || props.readOnly}
					dataSource={timeList}
					value={time}
					onSelectionChanged={(e) => {
						let newValue = setTimeForDate(date, e.selectedItem);
						setDate(newValue);
						setTime(e.selectedItem);

						props.onValueChanged && props.onValueChanged({ ...e, value: newValue } as NativeEventInfo<dxDateBox>);
					}}
					showClearButton={true}
				>
					<Validator>
						{
							props.timeRequired && !!date &&
							<RequiredRule message="Time is required"></RequiredRule>
						}
					</Validator>
				</SelectBox>
			</Item>
		</Box>
	)
}
